import { http } from '@/plugins/axios'

// 接口环境
const env = 'development'

// 配置接口环境对应域名 production为线上地址(必须) development为测试地址
const apisURL = {
  production: 'https://api.up-petroleum.com/api/v1/',
  development: 'https://apitest.up-petroleum.com/api/v1/',
}

// 生成接口baseUrl 生产环境强制为production
const baseURL = process.env.NODE_ENV == "production" ? apisURL['production'] : apisURL[env];

/**
 * 预约年审
 * @param car_number 车牌号
 * @param identification 车辆识别号
 * @param engine_number 发动机号码
 * @param register_date 注册日期
 * @param is_operated 是否运营(1|是 0|否)
 * @param name 姓名
 * @param tel 电话
 * @param get_car_date 取车日期
 * @param address 取/还车地址
 * @returns {Promise<unknown>}
 */
function applyFor(
  id_pic_front, // 身份证正面
  id_pic_back, // 身份证背面
  drive_pic, // 驾驶证照片
  name,//姓名
  tel,//电话
  get_car_date,//取车日期
  address//取/还车地址
) {
  return new Promise((resolve, reject) => {
    http({ method: 'post', url: 'getAeData', myBaseUrl: baseURL, isShowLoading: false, data: {
        id_pic_front,
        id_pic_back,
        drive_pic,
        name,
        tel,
        get_car_date,
        address
    }}).then(res => {
      resolve(res)
    }).catch(err => {
      reject(err)
    })
  })
}

/**
 * 获取年审订单列表
 * @param page 当前分页index
 * @returns {Promise<unknown>}
 */
function getAAVOrderList(page, status, isShowLoading=false) {
  return new Promise((resolve, reject) => {
    http({ method: 'get', url: 'AeIndex', myBaseUrl: baseURL, isShowLoading: isShowLoading, data: { page, status },})
      .then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
  })
}

/**
 * 获取年审订单详情
 * @param id 订单ID
 * @returns {Promise<unknown>}
 */
function getAAVOrderInfo(id, isShowLoading=true) {
  return new Promise((resolve, reject) => {
    http({ method: 'get', url: 'AeDetail', myBaseUrl: baseURL, isShowLoading: isShowLoading, data: { id },})
      .then(res => {
        resolve(res)
      }).catch(err => {
      reject(err)
    })
  })
}

/**
 * 取消预约
 * @param id
 * @returns {Promise<unknown>}
 */
function cancelById(id) {
  return new Promise((resolve, reject) => {
    http({ method: 'post', url: 'cancelAe', myBaseUrl: baseURL, isShowLoading: false, data: { id },})
      .then(res => {
        resolve(res)
      }).catch(err => {
      reject(err)
    })
  })
}


export {
  applyFor,
  getAAVOrderList,
  getAAVOrderInfo,
  cancelById,
}
